import React, { useEffect, useState } from 'react';
import './ProductShowcase.css';

// 1. COMPONENTE SLIDER COM SUPORTE A INTERVALO CUSTOMIZADO (Mantido original)
const MultiItemSlider = ({ items, renderItem, carouselId, desktopItems = 3, mobileItems = 1, interval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const itemsPerScreen = isMobile ? mobileItems : desktopItems;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1 > items.length - itemsPerScreen ? 0 : prev + 1));
    }, interval); 
    return () => clearInterval(timer);
  }, [items.length, itemsPerScreen, interval]);

  function handleNext() {
    setCurrentIndex((prev) => (prev + 1 > items.length - itemsPerScreen ? 0 : prev + 1));
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 < 0 ? Math.max(0, items.length - itemsPerScreen) : prev - 1));
  };

  return (
    <div className="custom-slider-wrapper" id={carouselId}>
      <button className="slider-control prev" onClick={handlePrev}>
        <i className="bi bi-chevron-left"></i>
      </button>
      
      <div className="slider-track-container">
        <div 
          className="slider-track" 
          style={{ transform: `translateX(-${currentIndex * (100 / itemsPerScreen)}%)` }}
        >
          {items.map((item) => (
            <div 
              className="slider-card-slot" 
              key={item.id}
              style={{ flex: `0 0 ${100 / itemsPerScreen}%` }}
            >
              {renderItem(item)}
            </div>
          ))}
        </div>
      </div>

      <button className="slider-control next" onClick={handleNext}>
        <i className="bi bi-chevron-right"></i>
      </button>
    </div>
  );
};

// Adicionado a prop 'globalSettings' para pescar as integrações do CMS dinamicamente
const ProductShowcase = ({ section, isRightAligned, globalSettings }) => {
  const [activePlantaTab, setActivePlantaTab] = useState(0);
  const [prevPlantaTab, setPrevPlantaTab] = useState(null); 
  const [isAnimating, setIsAnimating] = useState(false);
  const [zoomPlanta, setZoomPlanta] = useState(null);
  
  if (!section) return null;

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';
  const alignClass = isRightAligned ? "section-header-right" : "";
  const revealDirection = isRightAligned ? "reveal-from-left" : "reveal-from-right";

  const items = section.items || [];
  const bannerItem = items.find(i => i.category === 'banner_principal');
  
  const getBlockData = (cat) => ({
    intro: items.find(i => i.category === cat && i.is_intro),
    list: items.filter(i => i.category === cat && !i.is_intro).sort((a,b) => a.item_order - b.item_order)
  });

  const b1 = getBlockData('galeria_horizontal');
  const b2 = getBlockData('amenidade');
  const b3 = getBlockData('galeria_vertical');
  const b4 = getBlockData('planta');
  const b5 = getBlockData('destaque');

  // Lógica dinâmica para capturar e limpar a máscara de telefone vinda do painel
  const rawPhone = globalSettings?.whatsapp_number || '5491445429'; 
  const cleanPhone = rawPhone.replace(/\D/g, '');
  const whatsappUrl = `https://wa.me/${cleanPhone}?text=Entrei%20no%20site%20do%20Jurer%C3%AA%20Blue%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es`;

  return (
    <section id={section.slug} className="beneficios-master-section" style={{ backgroundColor: section.background_color || '#fff' }}>
      
      {/* 1. BANNER DE TOPO */}
      {bannerItem && (
        <div className="banner-top-wrapper">
          <img src={`${backendUrl}${bannerItem.images?.[0]?.image_url}`} alt="Banner" className="banner-img-achatada" />
          <div className="container banner-content-overlay">
            <div className={`pt-5 mt-2 ${alignClass}`}>
              {/* Extrai as cores do campo icon_class */}
              {(() => {
                let titleColor = '#ffffff'; // Cor Padrão fallback
                let descColor = '#ffffff';  // Cor Padrão fallback
                
                if (bannerItem.icon_class && bannerItem.icon_class.includes('|')) {
                  const colors = bannerItem.icon_class.split('|');
                  titleColor = colors[0];
                  descColor = colors[1];
                }

                return (
                  <>
                    <h2 
                      className={`fonte-primaria display-4 section-title reveal-element ${revealDirection} duration-10`}
                      style={{ 
                        color: titleColor,
                        textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
                        WebkitTextStroke: '0.5px rgba(255,255,255,0.6)'
                      }}
                    >
                      {bannerItem.title}
                    </h2>
                    {bannerItem.description && (
                      <h4 
                        className={`fonte-terciaria section-subtitle mt-2 reveal-element ${revealDirection} duration-12`}
                        style={{ 
                          color: descColor,
                          textShadow: '1px 1px 6px rgba(0,0,0,0.8)',
                          WebkitTextStroke: '0.3px rgba(255,255,255,0.4)'
                        }}
                      >
                        {bannerItem.description}
                      </h4>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}

      <div className="container pb-5">
        {/* BLOCO 1: GALERIA 1:1 */}
        {(b1.intro || b1.list.length > 0) && (
          <div className="mb-5 py-4">
            {b1.intro && (
              <div className="text-center mb-5">
                <h3 className="fonte-primaria title-light">{b1.intro.title}</h3>
                <h5 className="fonte-terciaria subtitle-bloco my-0">{b1.intro.description}</h5>
              </div>
            )}
            {b1.list.length > 0 && (
              <MultiItemSlider 
                items={b1.list} 
                carouselId="b1"
                interval={5000}
                renderItem={(item) => (
                  <div className="card-beneficio ratio-1-1 shadow-sm">
                     <img src={`${backendUrl}${item.images?.[0]?.image_url}`} alt={item.title} />
                  </div>
                )}
              />
            )}
          </div>
        )}

        {/* BLOCO 2: AMENIDADES */}
        {(b2.intro || b2.list.length > 0) && (
          <div className="mb-5 py-4">
            {b2.intro && (
              <div className="text-center mb-5">
                <h3 className="fonte-cinzel title-light">{b2.intro.title}</h3>
                <h5 className="fonte-cinzel subtitle-light">{b2.intro.description}</h5>
              </div>
            )}
            {b2.list.length > 0 && (
              <MultiItemSlider 
                items={b2.list} 
                carouselId="b2"
                desktopItems={6} 
                mobileItems={2}
                interval={5500} 
                renderItem={(item) => (
                  <div className="amenidade-card-premium shadow-sm border">
                     {item.images?.[0]?.image_url ? (
                       <img 
                         src={`${backendUrl}${item.images[0].image_url}`} 
                         alt={item.title} 
                         className="amenidade-icon-img"
                       />
                     ) : (
                       <div className="amenidade-icon-placeholder"></div>
                     )}
                     <h6>{item.title}</h6>
                  </div>
                )}
              />
            )}
          </div>
        )}
        
        {/* BLOCO 3: GALERIA 9:16 */}
        {(b3.intro || b3.list.length > 0) && (
          <div className="mb-5 py-4">
            {b3.intro && (
              <div className="text-center mb-5">
                <h3 className="fonte-primaria title-light">{b3.intro.title}</h3>
                <h5 className="fonte-terciaria subtitle-bloco my-0">{b3.intro.description}</h5>
              </div>
            )}
            {b3.list.length > 0 && (
              <MultiItemSlider 
                items={b3.list} 
                carouselId="b3"
                desktopItems={4}
                interval={6000}
                renderItem={(item) => (
                  <div className="card-beneficio ratio-9-16 shadow-sm">
                     <img src={`${backendUrl}${item.images?.[0]?.image_url}`} alt={item.title} />
                  </div>
                )}
              />
            )}
          </div>
        )}

        {/* BLOCO 4: PLANTAS */}
        {(b4.intro || b4.list.length > 0) && (
          <div className="mb-5 py-5 bg-light rounded-4 shadow-sm border">
            {b4.intro && (
              <div className="text-center mb-4">
                 <h3 className="fonte-primaria title-light">{b4.intro.title}</h3>
                 <h5 className="fonte-terciaria subtitle-bloco my-0">{b4.intro.description}</h5>
              </div>
            )}
            {b4.list.length > 0 && (
              <>
                <ul className="nav border-0 mb-4 planta-tabs-custom row justify-content-center mx-0 align-items-stretch">
                  {b4.list.map((planta, index) => (
                    <li key={planta.id} className="nav-item col-6 col-md-auto mb-2 px-1 px-md-2 d-flex">
                      <button 
                        className={`btn-planta w-100 d-flex align-items-center justify-content-center text-center p-2 ${activePlantaTab === index ? 'active' : ''}`} 
                        onClick={() => {
                          if (index === activePlantaTab || isAnimating) return;
                          setPrevPlantaTab(activePlantaTab);
                          setActivePlantaTab(index);
                          setIsAnimating(true);
                          
                          setTimeout(() => {
                            setIsAnimating(false);
                            setPrevPlantaTab(null);
                          }, 1200); 
                        }}
                      >
                        {planta.title}
                      </button>
                    </li>
                  ))}
                </ul>

                <div className="planta-anim-container overflow-hidden p-1 p-md-3" style={{ display: 'grid', placeItems: 'center' }}>
                  {prevPlantaTab !== null && (
                    <img 
                      src={`${backendUrl}${b4.list[prevPlantaTab]?.images?.[0]?.image_url}`} 
                      alt="Planta Saindo" 
                      className="img-fluid rounded-4 planta-img-exit w-100" 
                      style={{ gridArea: '1 / 1', objectFit: 'contain' }} 
                    />
                  )}

                  <img 
                    key={activePlantaTab} 
                    src={`${backendUrl}${b4.list[activePlantaTab]?.images?.[0]?.image_url}`} 
                    alt="Planta Entrando" 
                    className={`img-fluid rounded-4 w-100 ${isAnimating ? 'planta-img-enter' : ''}`} 
                    style={{ gridArea: '1 / 1', objectFit: 'contain', cursor: 'zoom-in' }} 
                    onClick={() => setZoomPlanta(`${backendUrl}${b4.list[activePlantaTab]?.images?.[0]?.image_url}`)}
                  />
                </div>
              </>
            )}

            {zoomPlanta && (
              <div 
                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
                style={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 10000, cursor: 'zoom-out' }}
                onClick={() => setZoomPlanta(null)}
              >
                <img src={zoomPlanta} alt="Planta Ampliada" className="img-fluid p-2" style={{ maxHeight: '95vh', maxWidth: '100vw', objectFit: 'contain' }} />
              </div>
            )}
          </div>
        )}

        

      </div>

      {/* BLOCO 5: DESTAQUES */}
      {(b5.intro || b5.list.length > 0) && (
        <div className="bg-white py-5 shadow-lg border-top mb-5">
          <div className="container">
            {b5.intro && (
              <div className="text-center mb-2">
                {b5.intro.title && b5.intro.title.includes('|') ? (
                  <>
                    <h6 className="fonte-terciaria text-uppercase fw-bold mb-2" style={{ color: 'var(--cor-primaria-3)', letterSpacing: '2px', fontSize: '0.9rem' }}>
                      {b5.intro.title.split('|')[0].trim()}
                    </h6>
                    <h3 className="fonte-primaria title-light destaques-title">{b5.intro.title.split('|')[1].trim()}</h3>
                  </>
                ) : (
                  <h3 className="fonte-primaria title-light destaques-title">{b5.intro?.title || "Destaques"}</h3>
                )}
                <h5 className="fonte-terciaria subtitle-light mt-0">{b5.intro?.description || section.content}</h5>
              </div>
            )}

            <div>
              {b5.list.length > 0 && (
                <MultiItemSlider 
                  items={b5.list} 
                  carouselId="b5"
                  desktopItems={3}
                  mobileItems={1}
                  interval={6500}
                  renderItem={(item) => (
                    <div className="destaque-card-final p-4 text-center bg-white">
                      <img 
                        src={`${backendUrl}${item.images?.[0]?.image_url}`} 
                        alt="Icon" 
                        className="mb-3 mx-auto d-block" 
                        style={{ height: '100px', objectFit: 'contain' }} 
                      />
                      <h5 className="fw-bold mt-3 mb-2" style={{ color: 'var(--cor-primaria-5)' }}>{item.title}</h5>
                      <p className="text-muted mb-0 mx-auto" style={{ maxWidth: '90%' }}>{item.description}</p>
                    </div>
                  )}
                />
              )}
            </div>
          </div>
          {/* 🚀 NOVA INJEÇÃO: BOTÃO DINÂMICO DE CONVERSÃO DO WHATSAPP */}
        <div className="text-center mt-5 pt-2">
          <a 
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp-custom btn btn-lg px-5 py-3 fw-bold shadow-sm d-inline-flex align-items-center justify-content-center"
          >
            {/* TROCADO PARA BOOTSTRAP ICONS */}
            <i className="bi bi-whatsapp me-2 fs-4"></i> 
            QUERO INFORMAÇÕES
          </a>
        </div>
        </div>
      )}
      
    </section>
  );
};

export default ProductShowcase;